export default function animateScrollUp() {
  $('html, body').animate({
    'scrollTop': 0
  }, 1000);
}



// WEBPACK FOOTER //
// ./app/webpacker/src/js/modules/scroll_up.js